module.exports = __webpack_public_path__ + "img/measure.d49a7d77.svg";